import { API_BASE_URL } from './config';

const buildUrl = path => `${API_BASE_URL}${path}`;

const apiFetch = (path, options = {}) => {
  return fetch(buildUrl(path), options);
};

const apiJsonFetch = (path, body, options = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  return apiFetch(path, {
    ...options,
    headers,
    body: JSON.stringify(body),
  });
};

export { apiFetch, apiJsonFetch };
